var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h17.412v16H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d70022",
    d: "M16.917 6.16l-2.493-4.301A3.738 3.738 0 0011.198 0H6.213a3.76 3.76 0 00-3.226 1.84L.495 6.16a3.704 3.704 0 000 3.699l2.492 4.3C3.647 15.307 4.875 16 6.213 16h4.985a3.76 3.76 0 003.226-1.84l2.493-4.301c.66-1.148.66-2.57 0-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.917 6.16l-2.493-4.301A3.738 3.738 0 0011.198 0H6.213a3.76 3.76 0 00-3.226 1.84L.495 6.16a3.704 3.704 0 000 3.699l2.492 4.3C3.647 15.307 4.875 16 6.213 16h4.985a3.76 3.76 0 003.226-1.84l2.493-4.301c.66-1.148.66-2.57 0-3.7zm-.935 3.152l-2.492 4.3a2.65 2.65 0 01-2.292 1.313H6.213c-.934 0-1.814-.51-2.29-1.312l-2.493-4.3a2.62 2.62 0 010-2.643l2.492-4.301a2.65 2.65 0 012.291-1.312h4.985c.935 0 1.815.51 2.291 1.312l2.493 4.3a2.62 2.62 0 010 2.643z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.994 7.584V5.038a.567.567 0 00-.527-.566.56.56 0 00-.6.517l-.001.036V7.63a.187.187 0 01-.189.186.187.187 0 01-.188-.186V3.94a.567.567 0 00-.527-.567.561.561 0 00-.601.554V7.26a.187.187 0 01-.189.185.187.187 0 01-.188-.185V3.556A.56.56 0 008.419 3a.56.56 0 00-.565.556V7.63a.187.187 0 01-.188.186.187.187 0 01-.188-.186V4.31a.566.566 0 00-.527-.566.56.56 0 00-.6.516l-.001.038v3.286a.176.176 0 00-.007.046v1.714L5.026 7.799c-.169-.2-.345-.242-.464-.242A.562.562 0 004 8.12c0 .085.021.17.06.246l1.682 3.302A2.435 2.435 0 007.927 13h1.99c1.15-.001 2.082-.919 2.083-2.05V7.63a.195.195 0 00-.006-.046z",
    fill: "#fff"
  }))));
}
SvgHandIcon.displayName = 'HandIcon';
export default SvgHandIcon;